import { ChangeEvent, useState } from "react";
import { TextAreaFieldType } from "shared/types";
import FloatingInputWrapper from "shared/components/layouts/FloatingInputWrapper";

const TextAreaInput = ({
  id,
  placeholder,
  className,
  required,
  value,
}: TextAreaFieldType) => {
  const [fieldValue, setFieldValue] = useState<string>(value ? value : "");

  const handleOnChange = (
    e: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => {
    setFieldValue(e.target.value);
  };

  return (
    <FloatingInputWrapper
      id={id}
      placeholder={placeholder}
      shrink={fieldValue ? true : false}
      styleProps={{ height: "120px" }}
    >
      <textarea
        id={id}
        name={id}
        value={value}
        className={className}
        onChange={handleOnChange}
        required={required}
      ></textarea>
    </FloatingInputWrapper>
  );
};
export default TextAreaInput;
